/* eslint-disable @angular-eslint/component-selector */

import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { RequestQuotesDialogComponent } from '../request-quotes-dialog';

@Component({
  selector: 'request-quotes-button',
  standalone: false,
  templateUrl: './request-quotes-button.component.html',
  styleUrls: ['./request-quotes-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RequestQuotesButtonComponent {
  constructor(public dialog: MatDialog) {}

  openDialog() {
    this.dialog.open(RequestQuotesDialogComponent, {
      width: 'calc(100vw - 32px)',
      maxWidth: '1200px',
    });
  }
}
